"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var PresetRow_1 = require("./PresetRow");
var ui_1 = require("@vidazoo/ui");
var utils_1 = require("../../../../utils");
var MAX_ITEMS = 5;
var PresetsModal = /** @class */ (function (_super) {
    tslib_1.__extends(PresetsModal, _super);
    function PresetsModal(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.renderItem = function (preset) {
            var _a = _this.props, onSave = _a.onSave, onDelete = _a.onDelete, onSelect = _a.onSelect;
            return (React.createElement(PresetRow_1.default, { key: preset._id, preset: preset, onSave: onSave, onDelete: onDelete, onSelect: onSelect }));
        };
        _this.setFilter = function (filter) {
            if (filter === _this.state.type) {
                _this.setState({ type: "all" });
                return;
            }
            _this.setState({ type: filter });
        };
        _this.onChangeSearch = function (e) {
            _this.setState({ search: utils_1.normalizeEventValue(e) });
        };
        _this.state = {
            type: "all",
            search: ""
        };
        return _this;
    }
    PresetsModal.prototype.render = function () {
        var _this = this;
        var _a = this.props, presets = _a.presets, allowShared = _a.allowShared, onCreateReport = _a.onCreateReport, isLoading = _a.isLoading, others = tslib_1.__rest(_a, ["presets", "allowShared", "onCreateReport", "isLoading"]);
        var _b = this.state, type = _b.type, search = _b.search;
        var scrollableProps = {
            suppressX: true,
            className: theme.list
        };
        if (presets.length > MAX_ITEMS) {
            scrollableProps.height = MAX_ITEMS * 4.8;
        }
        var filteredPresets = presets.filter(function (preset) {
            var nameMatch = preset.name.toLowerCase().includes(search.toLowerCase());
            if (type === "shared") {
                return preset.shared && nameMatch;
            }
            if (type === "account") {
                return !preset.shared && nameMatch;
            }
            return nameMatch;
        });
        return (React.createElement(ui_1.Modal, tslib_1.__assign({ exitOnClickOutside: true, basic: true, windowClass: theme.modal }, others),
            React.createElement("div", null,
                React.createElement(ui_1.Label, { className: theme.label, monserrat: true, uppercase: true, spacing: 1.5, weight: 600 }, "Saved Presets"),
                allowShared ? (React.createElement("div", { className: theme.filters },
                    React.createElement("div", { onClick: function () { return _this.setFilter("shared"); }, className: theme.filter, style: type === "shared" ? { background: "#5e5e5e" } : {} }, "Shared"),
                    React.createElement("div", { onClick: function () { return _this.setFilter("account"); }, className: theme.filter, style: type === "account" ? { background: "#5e5e5e" } : {} }, "Account"))) : null,
                React.createElement("div", { className: theme.search },
                    React.createElement(ui_1.FormInput, { onChange: this.onChangeSearch, value: search, autoFocus: true, name: "search", label: "Search", fill: true, className: theme.input })),
                presets.length > 0 ? (React.createElement(ui_1.NativeScrollable, tslib_1.__assign({}, scrollableProps),
                    React.createElement("ul", null, filteredPresets.map(this.renderItem)))) : isLoading ? (React.createElement(ui_1.PageLoader, { gray: true, size: 3, message: "Loading presets..." })) : (React.createElement(ui_1.PageMessage, { className: theme.message, small: true, iconName: "icon-no-results", title: "No Presets", description: "Create your first report preset" })),
                React.createElement("div", { className: theme.actions },
                    React.createElement(ui_1.Button, { iconName: "icon-save", onClick: onCreateReport, medium: true, flat: true }, "Save Current report as preset")))));
    };
    PresetsModal.defaultProps = {};
    return PresetsModal;
}(React.Component));
exports.default = PresetsModal;
